import { Injectable, signal, WritableSignal } from '@angular/core';

import { NotificationModel } from '../../models/internals/notification.model';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private notificationsSignal: WritableSignal<NotificationModel[]> = signal<NotificationModel[]>([]);

  constructor() { }

  public sendNotification(notifications: NotificationModel[]): void {
    const currentNotifications = this.notificationsSignal();
    const updatedNotifications = [...currentNotifications, ...notifications];
    this.notificationsSignal.set(updatedNotifications);

    notifications.forEach(notification => {
      const duration = notification.duration ?? 10000;
      setTimeout(() => {
        this.removeNotification(notification);
      }, duration);
    });
  }

  public removeNotification(notification: NotificationModel): void {
    const currentNotifications = this.notificationsSignal();
    const index = currentNotifications.indexOf(notification);
    if (index !== -1) {
      currentNotifications.splice(index, 1);
      this.notificationsSignal.set([...currentNotifications]);
    }
  }

  get notifications(): NotificationModel[] {
    return this.notificationsSignal();
  }
}
